module.exports = __webpack_public_path__ + "static/img/empty.a7203faf.png";